import Config from "../config";

export const concatBaseMediaUrl = (url) => {
    return `${Config.env().BASE_IMG_PATH}/${url}`;
};
